import * as React from "react";
import { SVGProps } from "react";

const Ark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 1598" {...props}>
    <g fill="#f70000">
      <path d="M995 563 0 1588 1000 0l1000 1598z" />
      <path d="M1140 971H828l160-172 152 173m-600 281h896l-182-182-538 2v1l-176 176" />
    </g>
  </svg>
);

export default Ark;
